import isString from 'lodash/fp/isString';
import isBoolean from 'lodash/fp/isBoolean';
import { stringToBoolOrValue } from 'utils/envParsing';
import getEnv from 'utils/getEnv';
import * as flagFetchStatus from './constants/flagFetchStatus';

// Basically we want to support variant default, to do so we check if this is a boolean or string in env variable
export const activeOrVariantStructureFromEnv = envVariable => {
  const value = stringToBoolOrValue(envVariable);
  if (isString(value)) {
    return { active: true, variant: value };
  }
  if (isBoolean(value)) {
    return { active: value };
  }
  return {};
};

export default () => ({
  flagFetchStatus: flagFetchStatus.STATIC,
  // Flags as we receive them from the back-end.
  flags: {
    'sunset-agave-brush': activeOrVariantStructureFromEnv(
      process.env.REACT_APP_FLAG_SUNSET_AGAVE_BRUSH
    ),
    'prescription-scoring-ab-test': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_PRESCRIPTION_SCORING_AB_TEST')
    ),
    'kustomer-livechat-at-cart-ab-test': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_KUSTOMER_LIVECHAT_AT_CART_AB_TEST')
    ),
    'interstitial-screen-ab-test': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_INTERSTITIAL_SCREEN_AB_TEST')
    ),
    'kustomer-livechat': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_KUSTOMER_LIVECHAT')
    ),
    'email-capture-exit-popup': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_EMAIL_CAPTURE_EXIT_POPUP')
    ),
    'styling-gel': activeOrVariantStructureFromEnv(getEnv('REACT_APP_FLAG_STYLING_GEL')),
    'free-ca-shipping': activeOrVariantStructureFromEnv(getEnv('REACT_APP_FLAG_FREE_CA_SHIPPING')),
    'cart-redesign-ui': activeOrVariantStructureFromEnv(getEnv('REACT_APP_FLAG_CART_REDESIGN')),
    'attentive-abc-test': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_ATTENTIVE_ABC_TEST')
    ),
    'express-checkout-ab-test': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_EXPRESS_CHECKOUT_AB_TEST')
    ),
    'ab-test-read-more-collapsed-product-cart': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_AB_TEST_READ_MORE_COLLAPSED_PRODUCT_CART')
    ),
    'prescription-page-ab-test': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_PRESCRIPTION_PAGE_AB_TEST')
    ),
    'supplements-refill-pouches': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_SUPPLEMENTS_REFILL_POUCHES')
    ),
    'vanity-url': activeOrVariantStructureFromEnv(getEnv('REACT_APP_FLAG_VANITY_URL')),
    supplements: activeOrVariantStructureFromEnv(getEnv('REACT_APP_FLAG_SUPPLEMENTS')),
    'usps-delays-communication': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_USPS_DELAYS_COMMUNICATION')
    ),
    'winback-gift': activeOrVariantStructureFromEnv(getEnv('REACT_APP_FLAG_WINBACK_GIFT')),
    'shimmer-hair-oil': activeOrVariantStructureFromEnv(getEnv('REACT_APP_FLAG_SHIMMER_HAIR_OIL')),
    brushes: activeOrVariantStructureFromEnv(getEnv('REACT_APP_SHOW_BRUSHES')),
    'powder-challenge-finished': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_POWDER_CHALLENGE_FINISHED')
    ),
    'powder-challenge-closed': activeOrVariantStructureFromEnv(
      getEnv('REACT_APP_FLAG_POWDER_CHALLENGE_CLOSED')
    ),
  },
});
